import React from 'react';
import { SortButton } from '../../../../search/components/sort';
import { SearchProps } from '../../models/arc-epi-props';



interface BillingAccountsListLabelsProps {
	settings: SearchProps,
}

export const BillingAccountsListLabels = (props: BillingAccountsListLabelsProps) => {

	return (
		<div className='sort-table-row'>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.accountNumberLabel} name='account_number' />
			</div>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.accountNameLabel} name='account_name' />
			</div>
			<div className='sort-table-row-cell'>
				<SortButton label={props.settings?.accountCityLabel} name='billing_city' />
			</div>
			<div className='sort-table-row-cell'>
				<p className='input-label'>{props.settings?.enrolledMembersLabel}</p>
			</div>
			<div className='sort-table-row-cell'>
				<p className='input-label'>{props.settings?.amountDueLabel}</p>
			</div>
			<div className='sort-table-row-cell'>
				<p className='input-label'>{props.settings?.billingHistoryLabel}</p>
			</div>
			<div className='sort-table-row-cell'>
				<p className='input-label'>{props.settings?.invoicesLabel}</p>
			</div>
		</div>
	);

};